import Breakpoint, { MAX, MIN } from '@maxpreps/shared/styles/breakpoint';
import { useMediaQuery } from 'react-responsive';

const DESKTOP_QUERY = { minWidth: Breakpoint.Desktop };

export const useIsDesktop = (): boolean => useMediaQuery(DESKTOP_QUERY);

const MOBILE_QUERY = { maxWidth: Breakpoint.Tablet - 1 };
export const useIsMobile = (): boolean => useMediaQuery(MOBILE_QUERY);

export const useIsTablet = (andBelow = false, andAbove = false): boolean =>
  useMediaQuery({
    minWidth: andBelow ? MIN : Breakpoint.Tablet,
    maxWidth: andAbove ? MAX : Breakpoint.Desktop - 1
  });

export const useIsScreenSize = (minWidth = 0, maxWidth = 0): boolean =>
  useMediaQuery({
    minWidth: minWidth || MIN,
    maxWidth: maxWidth || MAX
  });
